import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"

export const PlusSquareRegular = (props) => {
  return <FontAwesomeIcon faIcon={faPlusSquare} {...props} />
}
